import agrmntImage from './assets/agreement.png';

export const selectAgrDemoData = {
  heading: 'An update for our partners',
  subHeading:
    "Make the most of our updated <span class='poppinsBlack'>Terms & Conditions</span> for superior rewards & additional benefits!",
  benefitsHeading: 'Benefits',
  benefits: [
    'Cashback on Bookings',
    'Promotional Discount on Bookings',
    'Wallet Recharge Incentives',
    'Invoices Generated on Agency Name',
    'Reward Program Eligibility',
  ],
  exstngAgrmntHeading: 'Existing Agreement',
  exstngAgrmnt: ['false', 'false', 'false', 'false', 'false'],
  exstngAgrmntBtn: {
    type: 'sec',
    title: 'Select & Continue',
  },
  newAgrmntHeading: 'New Agreement',
  newAgrmnt: ['true', 'true', 'Up to 1%', 'true', 'true'],
  newAgrmntBtn: {
    type: 'prm',
    title: 'Select & Continue',
  },
};

export const selectAgrDemoData1 = {
  navigationSec: {
    backBtn: true,
    expiryInfo: "SESSION EXPIRES IN : <span class='latoBlack'>09m 54s</span>",
    stepTrack: "STEP <span class='blackText'>3 OF 3</span>",
    step: '3',
  },
  heading: 'Agreement',
  benefitsHeading: 'myPartner platform benefits',
  benefits: [
    'Cashback on bookings',
    'Use Promotional Discount on bookings',
    'Wallet Recharge Incentive',
    'Invoices generated against',
    'Reward Program',
  ],
  exstngAgrmntHeading: 'Existing Agreement',
  exstngAgrmnt: ['false', 'false', 'false', "Customer's name", 'false'],
  exstngAgrmntBtn: {
    type: 'sec',
    title: 'Select & Continue',
  },
  newAgrmntHeading: 'New Agreement',
  newAgrmnt: ['true', 'true', 'Up to 1%', 'Agency name', 'true'],
  newAgrmntBtn: {
    type: 'prm',
    title: 'Select & Continue',
  },
};

export const selectAgrDemoData2 = {
  selectExstngAgrmnt: {
    imgObj: {
      src: agrmntImage,
      alt: 'agreement',
    },
    title: 'Are you sure you want to opt for the existing agreement?',
    benefits: [
      {
        icon: 'agrmntSprite agrmntSprite--crossIcon',
        text: 'Cashback on bookings',
      },
      {
        icon: 'agrmntSprite agrmntSprite--crossIcon',
        text: 'Use Promotional Discount on bookings',
      },
      {
        icon: 'agrmntSprite agrmntSprite--crossIcon',
        text: 'Wallet Recharge Incentive',
      },
    ],
    prmyBtnObj: {
      title: 'Go Back',
      routePath: '#',
    },
    tertiaryBtnObj: {
      title: 'Agree and Continue',
      routePath: '#',
    },
  },
};

export const selectAgrDemoData3 = {
  selectExstngAgrmnt: {
    imgObj: {
      src: agrmntImage,
      alt: 'agreement',
    },
    title: 'An important update for our partners!',
    subtitle: 'Enjoy exciting benefits on your bookings.',
    newBenefits: [
      {
        icon: 'agrmntSprite agrmntSprite--tickIcon',
        text: 'Earn cashback on bookings ',
      },
      {
        icon: 'agrmntSprite agrmntSprite--tickIcon',
        text: 'Use promo cash on bookings ',
      },
      {
        icon: 'agrmntSprite agrmntSprite--tickIcon',
        text:
          'Seamless flow of input tax credit from suppliers i.e. airlines, hotels to Customers having GSTINs',
      },
      {
        icon: 'agrmntSprite agrmntSprite--tickIcon',
        text: 'Wallet Recharge incentive, loyalty bonuses, and any other benefits* ',
      },
    ],
    agreeStatement: true,
    prmyBtnObj: {
      title: 'Agree and Continue',
      routePath: '#',
    },
    tertiaryBtnObj: {
      title: 'Verify Later',
      routePath: 'https://www.makemytrip.com/?action=smartbuy&open=browser',
    },
  },
};

export const selectAgrDemoData4 = {
  selectExstngAgrmnt: {
    imgObj: {
      src: agrmntImage,
      alt: 'agreement',
    },
    title:
      'You can continue to book on myPartner to enjoy the best prices & deals on flights & hotels',
    continueBkngBtn: {
      title: 'Continue to Booking',
      routePath: 'https://www.makemytrip.com/?action=smartbuy&open=browser',
      routePathPwa: 'https://www.makemytrip.com/flights/?action=smartbuy&open=browser',
    },
    enrollBenefitText: true,
  },
};

export const selectAgrDemoData5 = {
  selectExstngAgrmnt: {
    imgObj: {
      src: agrmntImage,
      alt: 'agreement',
    },
    title: 'A copy of your new agreement has been sent to',
    //subtitle: 'Now you get more out of every myPartner bookings.',
    continueBkngBtn: {
      title: 'Continue to Booking',
      routePath: 'https://www.makemytrip.com/?action=smartbuy&open=browser',
      routePathPwa: 'https://www.makemytrip.com/flights/?action=smartbuy&open=browser',
    },
  },
};
